import { UseFormRegister, UseFormRegisterReturn, FieldValues } from 'react-hook-form';
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"

interface InputFloatingProps {
    label: React.ReactNode;
    errorClasses?: string;
    formClasses?: string;
    additionalClasses?: string;
    labelClasses?: string;
    type?: string;
    errorMessage?: string | undefined;
    showError?: boolean;
    register?: UseFormRegister<FieldValues> | UseFormRegisterReturn<string>;
    disabled?: boolean;
    id?: string;
}

const InputFloating: React.FC<InputFloatingProps> = ({
    label = "",
    errorClasses = "text-sm font-medium text-destructive pt-1",
    type = "text",
    errorMessage = "",
    showError = false,
    register = {},
    disabled = false,
    id="",
    ...rest
}) => {
    return (
        <div className="flex flex-col w-full">
            <Label className="mb-2" htmlFor={id}>{label}</Label>
            <Input type={type} id={id} {...register} disabled={disabled} {...rest}/>
            { showError && (
                <p className={errorClasses}>
                    {errorMessage}
                </p>
            )}
        </div>
    )
}

export default InputFloating;
